import { ReactNode } from 'react';

import {
  AngleRight,
  Button,
  ChakraFlex,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import { UserMode, useModeContext } from '~/lib/contexts/ModeContext';

interface OptionCardProps {
  id?: string;
  logo: ReactNode;
  name: string;
  toMode: UserMode;
}

const { h6, labelBold } = EquipUITheme.typography;

const OptionCard = ({ id, logo: Logo, name, toMode }: OptionCardProps) => {
  const { setMode } = useModeContext();

  const handleNavigation = () => {
    setMode(toMode);
  };

  return (
    <ChakraFlex
      alignItems="center"
      backgroundColor="neutral.background.secondary"
      borderRadius="16px"
      direction="column"
      height="155px"
      id={`${id}__option-card`}
      margin="0px 4px"
      padding="24px"
      width="326px"
    >
      {Logo}
      <ChakraText
        {...h6}
        fontSize="16px"
        id={`${id}__option-card__text`}
        margin="16px 0"
      >
        {name}
      </ChakraText>
      <Button
        {...labelBold}
        id={`${id}__option-card__continue`}
        onClick={handleNavigation}
        padding="7px"
        rightIcon={<AngleRight fill="white" height="16px" width="16px" />}
        size="sm"
      >
        Continue
      </Button>
    </ChakraFlex>
  );
};

export default OptionCard;
